export default ({ service, request, serviceForMock, requestForMock, mock, faker, tools }) => ({
  dashBoardListApi(data = {}) {
    return request({
      url: '/digitalCenter/dashBoard/list',
      method: 'post',
      data
    })
  },
  dashBoardGetPrjTypeNumber(data = {}) {
    return request({
      url: '/digitalCenter/dashBoard/prjTypeNumber',
      method: 'post',
      data
    })
  },
  dashBoardFilesListApi(data = {}) {
    return request({
      url: '/digitalCenter/dashBoard/file/list',
      method: 'post',
      data
    })
  }
})